<template>
  <div class="manage-applications__flex-box">
    <div class="manage-applications__left-column">
      <div
        class="manage-applications__flex-box manage-applications__flex-right"
      >
        <p class="manage-applications__filter-text">Filter by:</p>

        <!-- Criteria One -->
        <DropdownSelection
          dropdown-type="filter"
          dropdown-name="criteria1"
          :options="dropdownOptions.criteria"
          placeholder="Criteria 1"
          @dropdownChange="updateFilters"
        ></DropdownSelection>

        <!-- Criteria Two -->
        <DropdownSelection
          dropdown-type="filter"
          dropdown-name="criteria2"
          :options="secondCriteria(criteria1Filter)"
          placeholder="Criteria 2"
          @dropdownChange="updateFilters"
        ></DropdownSelection>
      </div>

      <div class="manage-applications__tables">
        <GenericTable
          v-if="tableData(accounts).length"
          :table-header="ApplicationReceivedHeader"
          color-scheme="blue"
          :is-load-more="isLoadMoreShown"
          :column-ratio="[3, 6, 10, 35, 35, 11]"
          :loading-status="loadMoreStatus.name"
          :loading-status-active="
            loadMoreStatus.type === 'application received'
          "
          @loadMoreTableRows="$emit('load-more', 'application received')"
        >
          <GenericTableRow
            v-for="(account, index) in tableData(accounts)"
            :key="index"
            :column-ratio="[3, 6, 10, 35, 35, 11]"
            @dropdown-open="
              $emit('get-uploaded-images', {
                accountId: account.account_id,
                tableName: 'applicationReceived',
              })
            "
          >
            <template #column-1>
              <div class="generic-table__checkbox">
                <input
                  v-model="selectedAccounts"
                  :value="account.junifer_account_number"
                  type="checkbox"
                  @click.stop
                />
              </div>
            </template>
            <template #column-2>
              <span class="generic-table__account-id">
                {{ account.junifer_account_number }}
              </span>
            </template>
            <template #column-3>
              {{ account.primary_whd_criterion_text }}
            </template>
            <template #column-4>
              {{ account.secondary_whd_criterion_text }}
            </template>
            <template #column-5>
              {{ account.created_at.substring(0, 10) }}
            </template>
            <template #dropdown>
              <form
                class="generic-table__dropdown"
                @submit.prevent="submitAccountUpdate($event, account)"
              >
                <h3>
                  <strong>First name: </strong>
                  {{ account.first_name }}
                </h3>
                <h3>
                  <strong>Last name: </strong>
                  {{ account.family_name }}
                </h3>
                <h3>
                  <strong>Email: </strong>
                  {{ account.email }}
                </h3>
                <h3>
                  <strong>Contact number: </strong>
                  {{ account.phone_number }}
                </h3>
                <h3>
                  <strong>Supply address: </strong>
                  {{ account.customer_details.address }},
                  {{ account.customer_details.postcode }}
                </h3>
                <h3>
                  <strong>Communication preference: </strong>
                  {{ account.communication_preference }}
                </h3>

                <h3 v-if="account.images">
                  <strong>Eligibility proof: </strong>
                  <strong v-if="account.images.length === 0">
                    No documents uploaded
                  </strong>
                  <a
                    v-else-if="account.images.length === 1"
                    href="javascript:;"
                    @click="openProofModal(account.images[0])"
                  >
                    {{ account.images[0].name }}
                  </a>
                  <div v-else class="generic-list">
                    <ul>
                      <li
                        v-for="(image, imageIndex) in account.images"
                        :key="imageIndex"
                      >
                        <a href="javascript:;" @click="openProofModal(image)">
                          {{ account.images[imageIndex].name }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </h3>

                <div class="generic-table__customer-criteria">
                  <h3>
                    <strong>Update customer criterias</strong>
                  </h3>
                  <p>Criteria One</p>
                  <DropdownSelection
                    dropdown-name="criteria1"
                    :options="dropdownOptions.criteria"
                    :set-selected="account.primary_whd_criterion_id.toString()"
                    :has-placeholder="false"
                    @dropdownChange="registerChange($event, account)"
                  ></DropdownSelection>

                  <p>Criteria Two</p>
                  <DropdownSelection
                    dropdown-name="criteria2"
                    :options="
                      secondCriteria(
                        account.primary_whd_criterion_id.toString(),
                      )
                    "
                    :set-selected="
                      account.secondary_whd_criterion_id.toString()
                    "
                    :has-placeholder="false"
                    @dropdownChange="registerChange($event, account)"
                  ></DropdownSelection>
                </div>

                <div
                  class="generic-table__flex-box generic-table__flex-right generic-table__flex-wrap"
                >
                  <button
                    class="button button--blue"
                    :disabled="!account.account_data_changed.all"
                    type="submit"
                  >
                    Save Changes
                  </button>
                  <div
                    v-if="checkAccountUpdate(account, 'fail')"
                    class="generic-table__submit-error"
                  >
                    <i class="fas fa-exclamation-triangle"></i>Update failed:
                    <span>Please try resubmitting the form</span>
                  </div>
                  <div
                    v-if="checkAccountUpdate(account, 'success')"
                    class="generic-table__submit-success"
                  >
                    <i class="fa fa-check-circle"></i>Successfully updated
                  </div>
                </div>
              </form>
            </template>
          </GenericTableRow>
        </GenericTable>

        <p v-else>We have no datas from the selected type.</p>
      </div>
    </div>

    <div class="manage-applications__right-column manage-applications__sidebar">
      <SidebarCard>
        <template #header>
          <i class="fas fa-info-circle manage-applications__info-icon"></i>
          Application recieved
        </template>
        <p>
          Each row shows a customer who has successfully submitted an
          application through the website.
        </p>

        <div
          class="manage-applications__select-all manage-applications__flex-box manage-applications__flex-right"
        >
          <button
            class="button button--blue select-button"
            :disabled="!applicationReceivedTotal"
          >
            <input
              id="selectAllAcc"
              v-model="selectAll"
              type="checkbox"
              class="checkbox select-button__select-checkbox"
              :disabled="!applicationReceivedTotal"
              @click="select"
            />
            <span>
              <template v-if="selectAll">
                All accounts selected
                <i class="fas fa-check manage-applications__check-icon"></i>
              </template>
              <template v-else> Select all accounts </template>
            </span>
          </button>
        </div>
      </SidebarCard>

      <SidebarCard>
        <template #header> Process Applications </template>
        <p>
          When you’re ready to process this year’s applications, assign an agent
          and proceed.
        </p>
        <p>
          We will check if accounts are core group or closed. These application
          will be closed and the customer informed, the rest will be updated as
          per your request.
        </p>

        <hr />

        <p>
          <strong>Selected</strong>
          <span class="manage-applications__selected-total">
            {{ selectedAccounts.length }}
          </span>
        </p>

        <form @submit.prevent="submitForm">
          <!-- Assign accounts to -->
          <DropdownSelection
            dropdown-name="assignedTo"
            :options="dropdownOptions.assignedTo"
            placeholder="Assigned to"
            @dropdownChange="processApplications"
          ></DropdownSelection>

          <!-- Choose for audit/Approve application -->
          <DropdownSelection
            dropdown-name="processTo"
            :options="dropdownOptions.process"
            placeholder="Please select"
            @dropdownChange="processApplications"
          ></DropdownSelection>

          <div
            v-if="failedToProcess"
            class="manage-applications__process manage-applications__process-failed"
          >
            <i class="fas fa-exclamation-triangle"></i>
            <span>Process failed, please retry</span>
          </div>

          <div
            v-if="pendingProcessing && !successfullyProcessed"
            class="manage-applications__loading"
          >
            <img src="@/assets/icons/loading-bar.gif" />
          </div>

          <div
            v-if="successfullyProcessed && !selectedAccounts.length"
            class="manage-applications__process manage-applications__process-successful"
          >
            <i class="fa fa-check-circle"></i>
            <span>Successfully processed</span>
          </div>

          <div
            class="manage-applications__flex-box manage-applications__flex-right"
          >
            <button
              v-if="!pendingProcessing || successfullyProcessed"
              class="button button--blue"
              type="submit"
              :disabled="!selectedAccounts.length"
            >
              Process
            </button>
          </div>
        </form>
      </SidebarCard>

      <SidebarCard>
        <template #header> Close Applications </template>
        <p class="manage-applications__selected">
          <strong>Selected</strong>
          <span class="manage-applications__selected-total">
            {{ selectedAccounts.length }}
          </span>
        </p>

        <div
          class="manage-applications__flex-box manage-applications__flex-right process-crediting"
        >
          <button
            class="button button--blue"
            :disabled="!selectedAccounts.length"
            @click="submitCancellationStatusUpdate"
          >
            Close applications
          </button>
        </div>

        <div class="manage-applications__process-container">
          <div
            v-if="cancelledFailedToProcess"
            class="manage-applications__process manage-applications__process-failed"
          >
            <i class="fas fa-exclamation-triangle"></i>
            <span>Process failed, please retry</span>
          </div>
          <div
            v-if="cancelPendingProcessing && !cancelSuccessfullyProcessed"
            class="manage-applications__loading"
          >
            <img src="@/assets/icons/loading-bar.gif" />
          </div>
          <div
            v-if="cancelSuccessfullyProcessed"
            class="manage-applications__process manage-applications__process-successful"
          >
            <i class="fa fa-check-circle"></i>
            <span>Successfully processed</span>
          </div>
        </div>
      </SidebarCard>
    </div>

    <Modal
      :is-full-screen="true"
      :is-modal-open="isFilePreviewVisible"
      @closeModal="isFilePreviewVisible = false"
    >
      <template #body>
        <FilePreview :file-data="currentFile" />
        <p class="file-modal-text">{{ fileModalText }}</p>
      </template>
      <template #cancelButton>Close</template>
    </Modal>
  </div>
</template>

<script>
import { whdMixin } from "@/mixins/whdMixin"
import SidebarCard from "@/components/SidebarCard"
import GenericTable from "@/components/smartMeter/GenericTable"
import GenericTableRow from "@/components/smartMeter/GenericTableRow"
import DropdownSelection from "@/components/warmHomeDiscount/DropdownSelection"
import FilePreview from "@/components/FilePreview"
import Modal from "@soenergy/frontend-library/src/components/Modal"

export default {
  name: "ApplicationReceived",
  components: {
    SidebarCard,
    GenericTable,
    GenericTableRow,
    DropdownSelection,
    FilePreview,
    Modal,
  },
  mixins: [whdMixin],
  props: {
    accountList: {
      type: Array,
      default: () => [],
    },
    dropdownOptions: {
      type: Object,
      default: () => {},
    },
    failedProcessing: {
      type: Boolean,
      default: false,
    },
    pendingProcessing: {
      type: Boolean,
      default: false,
    },
    successfullyProcessed: {
      type: Boolean,
      default: false,
    },
    cancelFailedProcessing: {
      type: Boolean,
      default: false,
    },
    cancelPendingProcessing: {
      type: Boolean,
      default: false,
    },
    cancelSuccessfullyProcessed: {
      type: Boolean,
      default: false,
    },
    applicationReceivedTotal: {
      type: Boolean,
      default: false,
    },
    loadMoreStatus: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ApplicationReceivedHeader: [
        "",
        "Select",
        "Account Id",
        "Criteria 1",
        "Criteria 2",
        "Received",
      ],
      accounts: [],
      processAgent: "",
      processType: "",
      selectedAccounts: [],
      failedToProcess: this.failedProcessing,
      cancelledFailedToProcess: this.cancelFailedProcessing,
      selectAll: false,
      isFilePreviewVisible: false,
      currentFile: null,
    }
  },
  computed: {
    isLoadMoreShown() {
      return !this.searchSuccess
    },
    fileModalText() {
      const fileName = this.currentFile ? this.currentFile.name : ""
      return "Uploaded file: " + fileName
    },
  },
  watch: {
    accountList(newAccountList) {
      this.accounts = newAccountList.map((account) => ({
        account_data_changed: {
          cr1: false,
          cr2: false,
          agent: false,
          status: false,
          all: false,
          originalPrimaryCriteria: account.primary_whd_criterion_id,
        },
        accountUpdateFail: false,
        accountUpdateSuccess: false,
        ...account,
      }))
    },
    cancelSuccessfullyProcessed(value) {
      this.resetSelection()
    },
    successfullyProcessed(value) {
      this.resetSelection()
    },
    failedProcessing(value) {
      this.failedToProcess = value
    },
    cancelFailedProcessing(value) {
      this.cancelledFailedToProcess = value
    },
  },
  methods: {
    processApplications(selection) {
      switch (selection.name) {
        case "assignedTo":
          this.processAgent = selection.value
          break
        case "processTo":
          this.processType = selection.value
          break
        default:
          return
      }
    },
    submitForm() {
      let submissionData = {
        processingTab: "applicationReceived",
        data: {
          warm_home_discounts_interface: {
            account_numbers: this.selectedAccounts,
            new_attributes: {
              ark_status: this.processType,
              agent: this.processAgent,
            },
          },
        },
      }

      if (this.processAgent) {
        this.$emit("process-applications", submissionData)
      } else {
        this.failedToProcess = true
      }
    },
    submitCancellationStatusUpdate() {
      let submissionData = {
        processingTab: "cancelApplicationReceived",
        data: {
          warm_home_discounts_interface: {
            account_numbers: this.selectedAccounts,
            new_attributes: {
              ark_status: "no_evidence_provided",
            },
          },
        },
      }
      this.$emit("process-applications", submissionData)
    },
    resetSelection() {
      this.selectedAccounts = []
      this.failedToProcess = false
      this.cancelledFailedToProcess = false
    },
    select() {
      this.selectedAccounts = []
      if (!this.selectAll) {
        for (let i in this.accountList) {
          this.selectedAccounts.push(this.accountList[i].junifer_account_number)
        }
      }
    },
    openProofModal(item) {
      this.isFilePreviewVisible = true
      this.currentFile = item
    },
  },
}
</script>

<style lang="scss" scoped>
.manage-applications {
  &__select-all {
    display: inline-block;
    margin-top: $spacing-4;

    label {
      border-radius: 20px;
      padding: $spacing-2 $spacing-4 $spacing-2 $spacing-2;
      font-weight: $weight-bold;

      &:hover {
        cursor: pointer;
      }
    }

    input {
      opacity: 0;
    }
  }

  &__check-icon {
    padding-left: $spacing-1;
  }

  &__flex-box {
    display: flex;
  }
  &__flex-right {
    justify-content: flex-end;
  }
}

.generic-list {
  color: $water-dark;
  margin-top: 18px;
  margin-bottom: -$space-2;
}
</style>
